export default "__VITE_ASSET__5ea87471__"